import { useCallback, useEffect, useState } from "react";
import { getFavorites, toggleFavorite } from "@/utils/favorites";

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(getFavorites());
  }, []);

  const toggle = useCallback((id: string) => {
    const next = toggleFavorite(id);
    setFavorites(next);
    return next.includes(id);
  }, []);

  const isFav = useCallback((id: string) => favorites.includes(id), [favorites]);

  return { favorites, toggle, isFav };
}